// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiBreadcrumbs-ol {
  list-style: none;
  display: inline-block !important;
}

.MuiBreadcrumbs-ol li {
  float: left;
}

.MuiBreadcrumbs-ol li a {
  display: block;
  background: #cde3e0;
  text-decoration: none;
  position: relative;
  height: 28px;
  line-height: 28px;
  padding: 0 10px 0 5px;
  text-align: center;
  margin-right: 23px;
}

.MuiBreadcrumbs-ol li:nth-child(even) a {
  background-color: #cde3e0;
}

.MuiBreadcrumbs-ol li:nth-child(even) a:before {
  border-color: #cde3e0;
  border-left-color: transparent;
}

.MuiBreadcrumbs-ol li:nth-child(even) a:after {
  border-left-color: #cde3e0;
}

.MuiBreadcrumbs-ol li:first-child a {
  padding-left: 15px;
  border-radius: 5px 0 0 5px;
}

.MuiBreadcrumbs-ol li:first-child a:before {
  border: none;
}

.MuiBreadcrumbs-ol li:last-child a {
  padding-right: 15px;
  border-radius: 0 4px 4px 0;
  background: #dfe0e3;
  color: rgba(0, 0, 0, 0.54) !important;
}

.MuiBreadcrumbs-ol li:last-child a:after {
  border: none;
  background: #dfe0e3;
}

.MuiBreadcrumbs-ol li:last-child a:before {
  border-color: #dfe0e3;
  border-left-color: transparent;
}

.MuiBreadcrumbs-ol li:last-child a:hover {
  background: #c8c9cc;
  color: rgba(0, 0, 0, 0.54) !important;
}

.MuiBreadcrumbs-ol li:last-child a:hover:before {
  border-color: #c8c9cc;
  border-left-color: transparent;
}

.MuiBreadcrumbs-ol li:last-child a:hover:after {
  border-left-color: #c8c9cc;
}

.MuiBreadcrumbs-ol li a:before,
.MuiBreadcrumbs-ol li a:after {
  content: '';
  position: absolute;
  top: 0;
  border: 0 solid #cde3e0;
  border-width: 14px 10px;
  width: 0;
  height: 0;
}

.MuiBreadcrumbs-ol li a:before {
  left: -20px;
  border-left-color: transparent;
}

.MuiBreadcrumbs-ol li a:after {
  left: 100%;
  border-color: transparent;
  border-left-color: #cde3e0;
}

.MuiBreadcrumbs-ol li a:hover {
  color: #fff !important;
  background: var(--mui-palette-newStates-ongoing-color);
}

.MuiBreadcrumbs-ol li a:hover:before {
  border-color: var(--mui-palette-newStates-ongoing-color);
  border-left-color: transparent;
}

.MuiBreadcrumbs-ol li a:hover:after {
  border-left-color: var(--mui-palette-newStates-ongoing-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/breadcrumb/BreadCrumbStyle.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,wDAAwD;EACxD,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;AAC/D","sourcesContent":[".MuiBreadcrumbs-ol {\n  list-style: none;\n  display: inline-block !important;\n}\n\n.MuiBreadcrumbs-ol li {\n  float: left;\n}\n\n.MuiBreadcrumbs-ol li a {\n  display: block;\n  background: #cde3e0;\n  text-decoration: none;\n  position: relative;\n  height: 28px;\n  line-height: 28px;\n  padding: 0 10px 0 5px;\n  text-align: center;\n  margin-right: 23px;\n}\n\n.MuiBreadcrumbs-ol li:nth-child(even) a {\n  background-color: #cde3e0;\n}\n\n.MuiBreadcrumbs-ol li:nth-child(even) a:before {\n  border-color: #cde3e0;\n  border-left-color: transparent;\n}\n\n.MuiBreadcrumbs-ol li:nth-child(even) a:after {\n  border-left-color: #cde3e0;\n}\n\n.MuiBreadcrumbs-ol li:first-child a {\n  padding-left: 15px;\n  border-radius: 5px 0 0 5px;\n}\n\n.MuiBreadcrumbs-ol li:first-child a:before {\n  border: none;\n}\n\n.MuiBreadcrumbs-ol li:last-child a {\n  padding-right: 15px;\n  border-radius: 0 4px 4px 0;\n  background: #dfe0e3;\n  color: rgba(0, 0, 0, 0.54) !important;\n}\n\n.MuiBreadcrumbs-ol li:last-child a:after {\n  border: none;\n  background: #dfe0e3;\n}\n\n.MuiBreadcrumbs-ol li:last-child a:before {\n  border-color: #dfe0e3;\n  border-left-color: transparent;\n}\n\n.MuiBreadcrumbs-ol li:last-child a:hover {\n  background: #c8c9cc;\n  color: rgba(0, 0, 0, 0.54) !important;\n}\n\n.MuiBreadcrumbs-ol li:last-child a:hover:before {\n  border-color: #c8c9cc;\n  border-left-color: transparent;\n}\n\n.MuiBreadcrumbs-ol li:last-child a:hover:after {\n  border-left-color: #c8c9cc;\n}\n\n.MuiBreadcrumbs-ol li a:before,\n.MuiBreadcrumbs-ol li a:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  border: 0 solid #cde3e0;\n  border-width: 14px 10px;\n  width: 0;\n  height: 0;\n}\n\n.MuiBreadcrumbs-ol li a:before {\n  left: -20px;\n  border-left-color: transparent;\n}\n\n.MuiBreadcrumbs-ol li a:after {\n  left: 100%;\n  border-color: transparent;\n  border-left-color: #cde3e0;\n}\n\n.MuiBreadcrumbs-ol li a:hover {\n  color: #fff !important;\n  background: var(--mui-palette-newStates-ongoing-color);\n}\n\n.MuiBreadcrumbs-ol li a:hover:before {\n  border-color: var(--mui-palette-newStates-ongoing-color);\n  border-left-color: transparent;\n}\n\n.MuiBreadcrumbs-ol li a:hover:after {\n  border-left-color: var(--mui-palette-newStates-ongoing-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
